import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Box from "@material-ui/core/Box";
import { toast } from "react-toastify";
import { getBackendUrl } from "../../config";

const AvatarUploader = ({ setAvatar, avatar, companyId, color, name }) => {
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    if (!(avatar instanceof File)) {
      setPreviewImage(null);
      return;
    }
    const url = URL.createObjectURL(avatar);
    setPreviewImage(url);
    return () => URL.revokeObjectURL(url);
  }, [avatar]);

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!file) return;
    if (!["image/jpeg", "image/png", "image/webp", "image/gif"].includes(file.type)) {
      toast.error("Escolha uma imagem JPG, PNG, WebP ou GIF.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("A foto deve ter no máximo 5 MB.");
      return;
    }
    setAvatar(file);
  };

  const storedImage = typeof avatar === "string" && avatar && companyId
    ? `${getBackendUrl()}/public/company${companyId}/user/${encodeURIComponent(avatar)}`
    : undefined;
  const borderColor = /^#[0-9a-fA-F]{6}$/.test(color || "") ? color : "#111827";

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <div style={{ border: `3px solid ${borderColor}`, borderRadius: "50%", padding: 3, display: "inline-flex" }}>
        <Avatar
          src={previewImage || storedImage}
          alt={name || "Usuário"}
          style={{ width: 120, height: 120 }}
        >
          {(name || "U").charAt(0).toUpperCase()}
        </Avatar>
      </div>
      <input
        accept="image/jpeg,image/png,image/webp,image/gif"
        type="file"
        id="avatar-upload"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <label htmlFor="avatar-upload" style={{ marginTop: 10 }}>
        <Button variant="contained" component="span" startIcon={<CloudUploadIcon />}>
          Upload Avatar
        </Button>
      </label>
    </Box>
  );
};

export default AvatarUploader;
